var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer ease-in-out text-center inline-block px-2",on:{"click":function($event){return _vm.$emit('click')}}},[_c('p',{staticClass:"uppercase font-semibold text-xl opacity-50",class:[_vm.selected ? `opacity-100` : '']},[_vm._v(" "+_vm._s(_vm.dayOfWeek)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }